import { createSelector } from 'reselect';

const selectJobTypeList = (state) => state.jobType.list;

export const getJobData = (state) => state.jobType.data;

export const getJobTitleList = createSelector(
  [selectJobTypeList],
  (jobTypeList) => jobTypeList.map((job) => ({
    value: job.jobTitle,
    label: job.jobTitle,
    slug: job.slug,
    id: job._id
  }))
);



